import { DesignState } from '@context';

// promoteDraft deletes the draft object the controllers hold — re-point them at an attached draft
export const repointDetachedDraft = (design: DesignState | null): void => {
	if (!design?.bpController) return;
	const { blueprint, bpController, tdController } = design;
	if (blueprint.kitchens.findVersion(null) === bpController.kitchen) return;
	bpController.kitchenVersion = null;
	tdController?.setBlueprint(blueprint);
};
